
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		getAgentProductOrderList
	} from '@/api/order';
	import{
		getSearchDate,
		nextDay
	}from "@/utils/index"


	@Component({
		name: 'order-product',
		components: {
			PageFooter,
			PickerDate
		}
	})
	export default class OrderProduct extends Vue {
		private defThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png'
		private productNameKey = ''
		private IDKey = ''
		private list: any[] = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private filterTime:any = ''
		private tableloading=false

		private mounted() {
			this.recently30()
			this.getList()
		}

		private recently30(){
			// let date = new Date()
			// let lastdate = new Date(new Date().getTime()-1000*60*60*24*30)

			// let year = date.getFullYear()
			// let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1)
			// let day = date.getDate()>9?date.getDate():'0'+date.getDate()

			// let oldyear = lastdate.getFullYear()
			// let oldmonth = lastdate.getMonth()+1>9?lastdate.getMonth()+1:'0'+(lastdate.getMonth()+1)
			// let oldday = lastdate.getDate()>9?lastdate.getDate():'0'+lastdate.getDate()

			// this.filterTime = [[oldyear,oldmonth,oldday].join('-'),[year,month,day].join('-')].join('/')

			this.filterTime = [getSearchDate(2,false,-4)[0],getSearchDate(2,false,-1)[0]].join('/')
		}

		private exportExcel() {
			console.log('导出表单')
		}

		private changePage(e) {
			this.pageNo = e
			this.getList()
		}

		private async getList() {
			let param: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				Keywords:this.productNameKey,
			}
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				param.StartTime = dt[0];
				param.EndTime = nextDay(dt[1],1)
			}
			// if (this.IDKey) {
			// 	param.ProductId = +this.IDKey
			// }
			// if (this.productNameKey) {
			// 	param.Keywords = this.productNameKey
			// }
			try {
				this.tableloading = true
				const res: any = await getAgentProductOrderList(param);
				this.list = res.Result.Results;
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			} finally{
				this.tableloading = false
			}
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.IDKey = ''
			this.pageNo = 1;
			this.productNameKey = ''
			// this.filterTime = getSearchDate(1).join('/')
			this.recently30()
			this.getList()
		}

		private toDetail(id: number) {
			this.$router.push({
				name: 'Order_Product_detail',
				query: {
					id: id + '',
					filterTime:this.filterTime
				}
			})
		}
	}
